import { render, staticRenderFns } from "./CargoPath.vue?vue&type=template&id=47695896&scoped=true"
import script from "./CargoPath.vue?vue&type=script&lang=js"
export * from "./CargoPath.vue?vue&type=script&lang=js"
import style0 from "./CargoPath.vue?vue&type=style&index=0&id=47695896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47695896",
  null
  
)

export default component.exports